import React from 'react';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

const PosterCard = ({ item, isEditMode, showDescription = true }) => {
  return (
    <div className="poster-list-item">
      <h3>
        <ConditionalLink item={item} condition={!isEditMode}>
          {item.title}
        </ConditionalLink>{' '}
        {item?.ikergazte_authors &&
        item?.ikergazte_authors?.items &&
        item?.ikergazte_authors?.items.length > 0
          ? item?.ikergazte_authors?.items
              .map((ca, key) => {
                return <span key={key}>{ca.name}</span>;
              })
              .reduce((acc, cur) => [...acc, acc.length ? ', ' : '', cur], [])
          : ''}
      </h3>
      {showDescription && item.description}
    </div>
  );
};

export default PosterCard;
